import { OTP_RATE_LIMITED_CODE } from './phoneVerificationErrors';
import { TRADE_MAP_IMAGE_COOLDOWN_CODE } from './tradeMapShare';

/**
 * 429 responses whose own surface renders the agreed copy inline, so the global
 * 429 handler in store/services/baseQuery.ts must leave them alone.
 *
 * That handler treats a 429 as "the API is throttling this client": it toasts
 * "You're making requests too quickly" and pauses nav, Inbox and Send polling
 * for retryAfter seconds. OTP_RATE_LIMITED is not that. It is a per-account,
 * per-IP or per-number cap on SMS sends with a retryAfter of up to an hour, and
 * the phone verification step already shows its copy. Letting it through would
 * stack a second, contradicting toast and stall polling for up to an hour.
 *
 * TRADE_MAP_IMAGE_COOLDOWN is the same shape: the share modal uploads the map
 * PNG on open and the backend answers 429 inside 10 s of the previous upload.
 * The modal treats it as a no-op (the previous image stays the unfurl); letting
 * it through toasted a 15-minute wait and paused nav, Inbox and Send polling
 * for 900 s after two modal opens.
 *
 * Keep this an explicit list. Exempting "any 429 that carries a code" would
 * silently change the behaviour of every coded 429 added later.
 */
export const INLINE_HANDLED_429_CODES: ReadonlySet<string> = new Set([OTP_RATE_LIMITED_CODE, TRADE_MAP_IMAGE_COOLDOWN_CODE]);

export const isInlineHandled429 = (errorData: unknown): boolean => {
  if (!errorData || typeof errorData !== 'object') return false;
  const code = (errorData as { code?: unknown }).code;
  return typeof code === 'string' && INLINE_HANDLED_429_CODES.has(code);
};
